module.exports = __webpack_public_path__ + "static/wavy-background-top-82144bb47e371643c94c578a20ddbfda.png";